import { messageWarning } from '../../../components/message';
import { ModalWrap } from '../../../components/modal-wrap';
import { CommonSelect } from '../../../components/select';
import { getNeedSynSiteOptions } from '../../../lib';
import getFormatMessage from '../../../locales/get-format-message';

let selectedSite = '';

export const showSyncModal = (callback: (site: string) => Promise<boolean>) => {
  selectedSite = '';
  ModalWrap.show({
    title: '服务同步',
    children: (
      <div>
        <div style={{ marginBottom: 10 }}>请选择需要同步的站点：</div>
        <div>
          <CommonSelect
            options={getNeedSynSiteOptions()}
            onChange={(val) => {
              selectedSite = val;
            }}
          />
        </div>
      </div>
    ),
    oKText: getFormatMessage('Confirm'),
    cancelText: getFormatMessage('cancel'),
    onOk: async () => {
      if (!selectedSite) {
        messageWarning('请选择需要同步的站点');
        return false;
      }
      const res = await callback(selectedSite);
      if (res) {
        selectedSite = '';
      }
      return res;
    },
  });
};
